/*
 * @Description: 跳转通用页面
 * @Author: your name
 * @Date: 2022-02-16 17:06:57
 * @LastEditors: ljp364102
 * @LastEditTime: 2022-02-16 17:51:00
 */

import jumpHandler from './jump-handler';

/**
 * @description: 跳通用错误页
 * @param {*} params
 *  params = {
 *    errorCode = 0, // 错误码，可为空，默认0， 示例：-1、-2、3、4
 *    actUrl = '',  // 活动链接，可为空，为空时不展示“返回首页”按钮，示例：'https://cache.amap.com/activity/2022ParkingPage/index.html?id=111&index=234'
 *    actName = '', // 活动名称，可为空，示例：2022ActDemo
 *    logName = ''  // 埋点名称，可为空，默认：activity_common_error_page；不为空且不等于common_error_page时，需要产品鼹鼠提新埋点；
 *    hideTitle = 0, // 是否显示titlebar，默认不隐藏；1=隐藏标题，0=不隐藏；
 *  }
 * @param {*} type 'common' || 'overdue'，通用错误页或失效页
 * @param {*} definedFn 自定义事件
 * @return {*}
 */
function goErrorPage(params = {}, type = 'common', definedFn = null) {
  const {
    code = 0,
    actUrl = '',
    actName = '',
    logName = '',
    hideTitle = 0,
  } = params;
  const errorPage = {
  	common: 'https://cache.amap.com/activity/2022ErrorPage/index.html', // 通用错误页
    overdue: 'https://cache.amap.com/activity/2022ErrorPage/overdue.html', // 过期失效页
  };
  const errorUrl = `${errorPage[type]}?code=${code}&actUrl=${encodeURIComponent(actUrl)}&actName=${actName}&logName=${logName}&hideTitle=${hideTitle}`;
  if (definedFn && typeof definedFn === 'function') {
    definedFn(errorUrl);
  } else {
    jumpHandler(errorUrl, {
      delay: 0,
      isReplace: true,
      needSchema: false,
    });
  }
}

export default {
  goErrorPage
}